import { MenuDropdown } from '@/components/Common';
import { AlertModal } from '@/components/Layout/AlertModal/AlertModal';
import { ListItem } from '@/components/Ui';
import { useFaqList } from './FaqList.hook';

export const FaqList = () => {
  const {
    filteredFaqs,
    selectedFaqByCategory,
    setSelectedFaqByCategory,
    menuItems,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    isDeletingFaq,
    handleConfirmDelete,
    isPublishModalOpen,
    setIsPublishModalOpen,
    faqToTogglePublish,
    handleConfirmPublish,
    isUpdatingFaq,
  } = useFaqList();
  return (
    <div className="overflow-auto mb-6 pl-2">
      {filteredFaqs?.map((faq, index) => (
        <ListItem
          typeSubItemIsFaq={true}
          listItemStyle={`!bg-black !hover:border-l-[#FEC200] ${faq?._id === selectedFaqByCategory?._id ? '!border-l-[#FEC200]' : ''}`}
          leftBorderColor={faq?.isPublished ? '#FFF' : '#616163'}
          focused={faq?.isPublished === true}
          key={index}
        >
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <h3 className="text-[15.478px] not-italic font-bold leading-[16.509px]">
                {faq?.question}
              </h3>
            </div>
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <MenuDropdown
                menuItems={menuItems(faq)}
                dotsStyle="bg-[#FEC20033]"
              />
            </div>
          </div>
        </ListItem>
      ))}
      <AlertModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        title="Confirmation de suppression"
        message="Êtes-vous sûr de vouloir supprimer cette FAQ ? Cette action est irréversible."
        buttonTitle={isDeletingFaq ? 'Suppression en cours...' : 'Supprimer'}
        buttonCancelTitle="Annuler"
        handleConfirm={handleConfirmDelete}
      />

      <AlertModal
        isOpen={isPublishModalOpen}
        onClose={() => setIsPublishModalOpen(false)}
        title={
          faqToTogglePublish?.isPublished
            ? 'Confirmation de masquage'
            : 'Confirmation de publication'
        }
        message={
          faqToTogglePublish?.isPublished
            ? 'Êtes-vous sûr de vouloir masquer cette FAQ ?'
            : 'Êtes-vous sûr de vouloir publier cette FAQ ?'
        }
        buttonTitle={isUpdatingFaq ? 'En cours...' : 'Confirmer'}
        buttonCancelTitle="Annuler"
        handleConfirm={handleConfirmPublish}
      />
    </div>
  );
};
